import { useMutation, useQuery } from "@apollo/react-hooks";
import { Grid, makeStyles } from "@material-ui/core";
import { gql } from "apollo-boost";
import MUIDataTable from "mui-datatables";
import { default as React } from "react";
import { Helmet } from "react-helmet";
import ManualAuthUserDevice from "./ManualAuthUserDevice";
import UpdateIsLockedUserDevice from "./UpdateIsLockedUserDevice";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.headerHeight,
    flexGrow: 1,
    backgroundColor: theme.palette.gray,
    minHeight: `calc(100vh - ${theme.headerHeight})`,
    padding: theme.spacing(2),
    boxSizing: "border-box",
    "& .MuiTableCell-root": {
      fontSize: "13px"
    }
  },
  paper: theme.filterPaper
}));

const GET_USERS_DEVICE = gql`
  {
    userDevices {
      id
      name
      user {
        id
        email
        name
        apiToken
      }
      createdAt
      updatedAt
      isLocked
      platform
      version
      model
      activationDate
      isActive
    }
  }
`;

const DELETE_USER_DEVICE_ITEM = gql`
  mutation deleteUserDevice($id: ID!) {
    deleteUserDevice(input: { id: $id }) {
      userDevice {
        id
      }
    }
  }
`;

const UserDeviceAdmin = () => {
  const classes = useStyles();

  const { data, loading, error, refetch } = useQuery(GET_USERS_DEVICE);

  const [deleteItem] = useMutation(DELETE_USER_DEVICE_ITEM, {
    update(cache, { data }) {
      refetch();
    }
  });

  if (loading) return <></>;
  if (error) return <></>;

  const handleSuccess = e => {
    refetch();
  };

  const handleDelete = dataDelete => {
    const ids = [];

    dataDelete.data.map(it => {
      if (data.userDevices[it.index]) {
        ids.push(data.userDevices[it.index].id);
      }
      return () => {};
    });

    ids.map(id => {
      deleteItem({
        variables: {
          id: id
        }
      });
      return () => {};
    });
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Admin User Device Panel</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ManualAuthUserDevice handleSuccess={handleSuccess} />
        </Grid>
        <Grid item xs={12}>
          <UserDeviceTable obj={data} handleDelete={handleDelete} />
        </Grid>
      </Grid>
    </div>
  );
};

const UserDeviceTable = ({ obj: { userDevices }, handleDelete }) => {
  const data = userDevices.map(it => {
    return {
      ...it,
      isActive: it.isActive ? "Tak" : "Nie",
      isLocked: it.isLocked ? "Tak" : "Nie",
      action: <UpdateIsLockedUserDevice obj={it} />
    };
  });

  const columns = [
    {
      name: "name",
      label: "Device name",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "user.email",
      label: "User E-mail",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "isActive",
      label: "Aktywny",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "isLocked",
      label: "Zablokowany",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "action",
      label: "Zablokować?",
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "platform",
      label: "Platform",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "model",
      label: "Model",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "version",
      label: "Version",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "createdAt",
      label: "Dodano",
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "activationDate",
      label: "Aktywowano",
      options: {
        filter: false,
        sort: true
      }
    }
  ];

  return (
    <>
      <MUIDataTable
        title={"Devices"}
        data={data}
        columns={columns}
        options={{
          download: false,
          print: false,
          selectableRowsHeader: true,
          onRowsDelete: handleDelete
        }}
      />
    </>
  );
};

export default UserDeviceAdmin;
